/**
 * WhatsApp links (wa.me). Argentine mobiles need a 9 after the country code (54 9 11 …): a number
 * saved without it ("+54 11 3652-8119") still gets a working link.
 */
export function whatsappDigits(phone: string | null | undefined): string | null {
  let digits = (phone ?? "").replace(/\D/g, "");
  if (digits.startsWith("54") && !digits.startsWith("549") && digits.length === 12) digits = `549${digits.slice(2)}`;
  return digits.length >= 8 ? digits : null;
}

/** https://wa.me/<digits>?text=<message>, or null without a usable number. */
export function whatsappUrl(phone: string | null | undefined, text?: string): string | null {
  const digits = whatsappDigits(phone);
  if (!digits) return null;
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}
